import createCounterInlineFabric from "../../../general/CoreHeader/components/CounterInline/counterInlineFabric";
import { createDisplayNameForHeader } from "../../utils/createDisplayName";
import { createTestIdForHeader } from "../../utils/createTestId";

const displayName = createDisplayNameForHeader("CounterInline");
const testId = createTestIdForHeader("counter-inline");

const HeaderCounterInline = createCounterInlineFabric(displayName, testId);

export default HeaderCounterInline;
